import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { emptyFields } from '../../utilities/common-file';
import { OrdersService } from '../orders.service';
import { CommonService } from 'src/app/utilities/common-service';
import { NzDrawerRef, NzModalRef, NzModalService } from 'src/app/utilities/ng-zorro-antd.module';
import { UntypedFormGroup } from '@angular/forms';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { OrdersSearch } from 'src/app/models/orders';
import * as moment from 'moment';

@Component({
  selector: 'app-order-logs',
  templateUrl: './order-logs.component.html'
})
export class OrderLogsComponent implements OnInit {

  loading = false;
  emptyField = emptyFields;
  @Input() selectedUserId: any;
  loadingForStatusHistory = false;
  textLoadingForStatusHistory = '';
  merchantOrderList = [];
  isVisible=false;
  isEdit=false;
  orderLogForm: UntypedFormGroup;
  action: any;
  logModal: NzModalRef;
  selectedLog : any;

  private tableData: NzTableData<OrdersSearch, any> = new NzTableData <OrdersSearch, any>(new OrdersSearch(), 'name');


  constructor(
    private commonService: CommonService, 
    private drawerRef: NzDrawerRef, 
    private modal: NzModalService,
    private orderService: OrdersService,)
     { }

  ngOnInit() {
    this.selectedLog = this.selectedUserId.merchantOrderDetails[0];
    this.getOrderLogs();
  }
// FOr Status History Timeline
getOrderLogs() {
  this.loadingForStatusHistory = true;
  this.textLoadingForStatusHistory = 'Loading';
  const value = {
    merchantOrderId:this.selectedLog.merchantOrderId,
    // orderStatus:this.selectedUserId.orderStatus,
    appCode:this.selectedUserId.appCode,


  };
  this.orderService.getOrderLogs(value).subscribe((response: any) => {
    console.log('logs',response);
    if (response.data && response.data.merchantOrderLogs && response.data.merchantOrderLogs.length > 0) {
      this.loadingForStatusHistory = false;
      this.textLoadingForStatusHistory = '';
      this.merchantOrderList = response.data.merchantOrderLogs;
    } else {
      this.loadingForStatusHistory = false;
      this.merchantOrderList = [];
      this.textLoadingForStatusHistory = 'No Data Found';
    }
  }, () => {
    this.loadingForStatusHistory = false;
    this.merchantOrderList = [];
    this.textLoadingForStatusHistory = 'No Data Found';
  });
}
createTplModal(
  tplTitle: TemplateRef<{}>,
  tplContent: TemplateRef<{}>,
  tplFooter: TemplateRef<{}>,
  data
) {
  // const obj = JSON.stringify(data.action);
  // console.log("action",obj);
  if(data.action){
    this.action= JSON.parse(data.action);
    this.action.createdBy = this.selectedUserId.createdByUser.fullName;
    if(this.selectedUserId.updatedByUser){
      this.action.updatedBy = this.selectedUserId.updatedByUser.fullName;
    }
    this.action.createdDate = moment(this.selectedUserId.createdDate).local().format("YYYY-MM-DD hh:mm A");
    this.action.updatedDate = moment(this.selectedUserId.updatedDate).local().format("YYYY-MM-DD hh:mm A");
  }
  else{
    this.action = 'No data found';
  }
  this.logModal = this.modal.create({
    nzTitle: tplTitle,
    nzContent: tplContent,
    nzFooter: tplFooter,
    nzMaskClosable: false,
    nzClosable: false,
    nzWidth: '60%',
    nzOnOk: () => console.log('Click ok'),
  });
}

destroyModal() {
  this.logModal.destroy();
}
getOrderStatus(status) {
  return this.commonService.getOrderStatus(status);
}
getOrderStatusColor(status) {
  return this.commonService.getOrderStatusColor(status);
}
close() {
  this.drawerRef.close();
}
}
